import { RouteComponentProps } from "@reach/router";
import { Layout } from "antd";
import React, { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import Header from "./header";

const styles = {
  container: {
    height: "100vh",
  },
  content: {
    padding: 20,
  },
};

interface Props extends RouteComponentProps {
  children: ReactNode;
}
const HomeLayout = (props: Props) => {
  const { t } = useTranslation();
  return (
    <Layout style={styles.container}>
      <Layout.Header>
        <Header />
      </Layout.Header>
      <Layout.Content style={styles.content}>{props.children}</Layout.Content>
      <Layout.Footer>
        Hack Harvest - 2021 - {t("All rights reserved.")}
      </Layout.Footer>
    </Layout>
  );
};

export default HomeLayout;
